import React from "react";
import { TextField, Box, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../styles/profile.scss";
import "../styles/popup.scss";

const AddPreferencePopup = ({ isOpen, onClose, onSave, loading }) => {
  const [question, setQuestion] = React.useState("");
  const [answer, setAnswer] = React.useState("");

  const handleSave = () => {
    if (question && answer) {
      onSave({ question, answer });
      setQuestion("");
      setAnswer("");
    }
  };

  const handleClose = () => {
    setQuestion("");
    setAnswer("");
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="add-preference-modal-title"
      aria-describedby="add-preference-modal-description"
      className="common-popup-overlay"
    >
      <Box className="common-popup-container">
        <Box className="popup-header">
          <div className="popup-title-box">
            <div id="add-preference-modal-title" className="popup-title">
              Add New Preference
            </div>
          </div>
          <IconButton onClick={handleClose} className="popup-close-btn">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box className="popup-content ">
          <Box
            sx={{ display: "flex", flexDirection: "column", gap: 3 }}
            className="popup-form-group"
          >
            <div
              style={{
                color: "var(--color-text-light)",
                fontSize: "0.875rem",
                fontWeight: 600,
              }}
            >
              Preference Question
            </div>
            <TextField
              variant="outlined"
              fullWidth
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
            />
            <div
              style={{
                color: "var(--color-text-light)",
                fontSize: "0.875rem",
                fontWeight: 600,
              }}
            >
              Preference Answer
            </div>
            <TextField
              variant="outlined"
              fullWidth
              multiline
              rows={3}
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
            />
          </Box>
        </Box>

        <Box className="popup-actions">
          <button
            className="add-preference-btn"
            onClick={handleSave}
            disabled={loading || !question || !answer}
            style={{
              minWidth: 120,
              color: "white",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 500,
              borderRadius: "8px",
              py: 1,
              "&:disabled": {
                backgroundColor: "#ccc",
                color: "#999",
              },
            }}
          >
            {loading ? "Saving..." : "Update"}
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddPreferencePopup;
